import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Lottie from "lottie-react";
import spinningWheel from "../assets/spinningWheel.json";

import serviceImage1 from "../assets/serviceImage1.jpg";
import serviceImage2 from "../assets/serviceImage2.jpg";
import serviceImage3 from "../assets/serviceImage3.jpg";
import serviceImage4 from "../assets/serviceImage4.jpg";

import "./Services.css";

const serviceData = (t) => [
  {
    title: t('services.sections.masterTheRoads.title'),
    description: t('services.sections.masterTheRoads.description'),
    image: serviceImage1,
  },
  {
    title: t('services.sections.conquerTheTrack.title'),
    description: t('services.sections.conquerTheTrack.description'),
    image: serviceImage2,
  },
  {
    title: t('services.sections.understandTheMachine.title'),
    description: t('services.sections.understandTheMachine.description'),
    image: serviceImage3,
  },
  {
    title: t('services.sections.driveBeyondLimits.title'),
    description: t('services.sections.driveBeyondLimits.description'),
    image: serviceImage4,
  },
];

export default function Services() {
  const { t } = useTranslation();
  const scrollRef = useRef();
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);

  const updateScrollState = () => {
    const el = scrollRef.current;
    setIsAtStart(el.scrollLeft <= 0);
    setIsAtEnd(el.scrollLeft + el.offsetWidth >= el.scrollWidth - 1);
  };

  const scroll = (dir) => {
    const container = scrollRef.current;
    const card = container.querySelector(".service-card");
    const scrollAmount = card.offsetWidth + 24;
    container.scrollBy({
      left: dir === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const el = scrollRef.current;
    el.addEventListener("scroll", updateScrollState);
    updateScrollState();
    return () => el.removeEventListener("scroll", updateScrollState);
  }, []);

  return (
    <section className="services-section">
      <div className="container">
          <div className="services-header">
            <div className="header-row">
              <Lottie animationData={spinningWheel} className="spinning-wheel" />
              <h2>{t('services.header')}</h2>
            </div>
            <p>{t('services.intro')}</p>
          </div>

          <div className="services-carousel">
            <button
              className={`carousel-arrow left ${isAtStart ? "disabled" : ""}`}
              onClick={() => scroll("left")}
              disabled={isAtStart}
            >
              <svg viewBox="0 0 24 24" width="36" height="36">
                <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>

            <div className="carousel-track" ref={scrollRef}>
              {serviceData(t).map((item, index) => (
                <div className="service-card" key={index}>
                  <div className="service-card-image-wrapper">
                    <img src={item.image} alt={item.title} />
                    <h4 className="service-card-title">{item.title}</h4>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>

            <button
              className={`carousel-arrow right ${isAtEnd ? "disabled" : ""}`}
              onClick={() => scroll("right")}
              disabled={isAtEnd}
            >
              <svg viewBox="0 0 24 24" width="36" height="36">
                <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
        </div>
    </section>
  );
}
